import RecipesContainerComponent from "./RecipesContainerComponent";

export default RecipesContainerComponent;